import { centerable, stylable } from '../decorators';
import { generateHeadingId } from '@intercom/embercom-prosemirror-composer/lib/helpers/id-generator';
export const headingSpec = stylable(centerable({
  content: 'inline*',
  attrs: {
    type: {
      default: 'heading'
    },
    idAttribute: {
      default: ''
    }
  },
  defining: true,
  group: 'block',
  parseDOM: [{
    tag: 'h1',
    getAttrs() {
      return {
        idAttribute: generateHeadingId()
      };
    }
  }, {
    tag: 'p[role=heading][aria-level="1"]',
    priority: 60,
    getAttrs() {
      return {
        idAttribute: generateHeadingId()
      };
    }
  }],
  toDOM(node) {
    return ['h1', {
      id: node.attrs.idAttribute
    }, 0];
  }
}));
export const subheadingSpec = stylable(centerable({
  content: 'inline*',
  attrs: {
    type: {
      default: 'subheading'
    },
    idAttribute: {
      default: ''
    }
  },
  defining: true,
  group: 'block',
  parseDOM: [{
    tag: 'h2',
    getAttrs() {
      return {
        idAttribute: generateHeadingId()
      };
    }
  }, {
    tag: 'p[role=heading][aria-level="2"]',
    priority: 60,
    getAttrs() {
      return {
        idAttribute: generateHeadingId()
      };
    }
  }, {
    tag: 'h3',
    getAttrs() {
      return {
        idAttribute: generateHeadingId()
      };
    }
  }, {
    tag: 'p[role=heading][aria-level="3"]',
    priority: 60,
    getAttrs() {
      return {
        idAttribute: generateHeadingId()
      };
    }
  }, {
    tag: 'h4',
    getAttrs() {
      return {
        idAttribute: generateHeadingId()
      };
    }
  }, {
    tag: 'p[role=heading][aria-level="4"]',
    priority: 60,
    getAttrs() {
      return {
        idAttribute: generateHeadingId()
      };
    }
  }],
  toDOM(node) {
    return ['h2', {
      id: node.attrs.idAttribute
    }, 0];
  }
}));
export const subheading3Spec = stylable(centerable({
  content: 'inline*',
  attrs: {
    type: {
      default: 'subheading3'
    },
    idAttribute: {
      default: ''
    }
  },
  defining: true,
  group: 'block',
  parseDOM: [],
  toDOM(node) {
    return ['h3', {
      id: node.attrs.idAttribute
    }, 0];
  }
}));
export const subheading4Spec = stylable(centerable({
  content: 'inline*',
  attrs: {
    type: {
      default: 'subheading4'
    },
    idAttribute: {
      default: ''
    }
  },
  defining: true,
  group: 'block',
  parseDOM: [],
  toDOM(node) {
    return ['h4', {
      id: node.attrs.idAttribute
    }, 0];
  }
}));